module.exports = __webpack_public_path__ + "img/load_balancer.5e65b148.svg";